export const recommendationsAPIInitialState = {
  isModalOpen: null,
  processData: null,
  showProcessStatusCard: false,
  workflowOutput: null,
  workflowNoContent: false,
};
